import { SeekbarInfo } from '../PlayerModel';
import { StreamInfo } from '../streamInfo/StreamInfo';

export class UiEventHandlers {
  updateTitleBarHandler: (info: StreamInfo) => any;
  spinnerHandler: (enabled: boolean) => any;
  errorHandler: (msg: string | undefined) => any;
  updatePosition: (info: SeekbarInfo) => any;
  updateControlButtons: (buttons: string[]) => any;
  updateTrickPlay: (forward: boolean, speed: number) => any;
  constructor() {
    this.updateTitleBarHandler = () => {
      return;
    };
    this.spinnerHandler = () => {
      return;
    };
    this.errorHandler = () => {
      return;
    };
    this.updatePosition = () => {
      return;
    };
    this.updateControlButtons = () => {
      return;
    };
    this.updateTrickPlay = () => {
      return;
    };
  }
}
